import { Typography } from "antd";

const { Title, Paragraph, Text } = Typography;

const LAST_UPDATED = "April 21, 2026";

export default function PrivacyPolicy() {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f8fafc",
        padding: "48px 20px",
      }}
    >
      <div
        style={{
          maxWidth: 820,
          margin: "0 auto",
          background: "#fff",
          border: "1px solid #e2e8f0",
          borderRadius: 12,
          padding: "40px 48px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
        }}
      >
        <Typography>
          <Title level={2} style={{ marginTop: 0 }}>
            Privacy Policy
          </Title>
          <Text type="secondary">Last updated: {LAST_UPDATED}</Text>

          <Paragraph style={{ marginTop: 24 }}>
            This Privacy Policy describes how Access Warehousing ("we", "us",
            or "our") collects, uses, and protects information when you use our
            platform. By using the service, you agree to the terms described
            below.
          </Paragraph>

          <Title level={4}>1. Information We Collect</Title>
          <Paragraph>
            We collect information you provide directly (such as name, email,
            phone number, and role when you register or are invited), as well
            as operational data you or your organization upload, including
            weightment slips, driver and labour records, rake and wagon
            details, and related documents.
          </Paragraph>
          <Paragraph>
            We also collect limited technical information automatically, such
            as IP address, browser type, device identifiers, and usage logs,
            to operate and secure the service.
          </Paragraph>

          <Title level={4}>2. How We Use Information</Title>
          <Paragraph>We use collected information to:</Paragraph>
          <ul>
            <li>Provide, maintain, and improve the platform and its features.</li>
            <li>
              Process and store warehouse operations data on behalf of your
              organization.
            </li>
            <li>
              Authenticate users, manage access, and keep the service secure.
            </li>
            <li>
              Send transactional communications such as reminders, invitations,
              and service notifications.
            </li>
            <li>Comply with legal obligations and enforce our terms.</li>
          </ul>

          <Title level={4}>3. How We Share Information</Title>
          <Paragraph>
            We do not sell your personal information. We may share information
            with service providers (such as cloud hosting and email delivery
            partners) acting on our behalf under confidentiality obligations,
            with other members of your organization in line with their role,
            or when required by law or to protect rights and safety.
          </Paragraph>

          <Title level={4}>4. Data Storage and Security</Title>
          <Paragraph>
            Data is stored on secured cloud infrastructure with access
            controls, encryption in transit, and routine backups. While we
            implement reasonable safeguards, no system can be guaranteed
            completely secure, and you use the service at your own risk.
          </Paragraph>

          <Title level={4}>5. Data Retention</Title>
          <Paragraph>
            We retain information for as long as your organization's account is
            active or as needed to provide the service, comply with legal
            obligations, resolve disputes, and enforce our agreements. Deleted
            records may remain in backups for a limited period before being
            purged.
          </Paragraph>

          <Title level={4}>6. Your Rights</Title>
          <Paragraph>
            Depending on your jurisdiction, you may have rights to access,
            correct, export, or delete your personal information, and to
            object to or restrict certain processing. Requests can be made by
            contacting us using the details below. We may need to verify your
            identity before fulfilling a request.
          </Paragraph>

          <Title level={4}>7. Cookies and Local Storage</Title>
          <Paragraph>
            We use cookies and browser local storage to keep you signed in and
            remember preferences. You can clear or block these through your
            browser, but some features may stop working as a result.
          </Paragraph>

          <Title level={4}>8. Children's Privacy</Title>
          <Paragraph>
            The service is not intended for children under 16, and we do not
            knowingly collect personal information from them.
          </Paragraph>

          
        </Typography>
      </div>
    </div>
  );
}
